import {Button, Form, FormProps, Input, Modal, Select, Upload} from 'antd'
import {FC, useState} from 'react'
import * as API_TREES from "../../../shared/http/trees";
import Constants from "../../../const/Constants";
import {UploadOutlined} from "@ant-design/icons";

interface CreateTreeProps {
    isOpen: boolean,
    close: () => void
}

export const CreateTree: FC<CreateTreeProps> = ({isOpen, close}) => {

    const [loading, setLoading] = useState<boolean>(false)
    const [form] = Form.useForm()

    type FieldType = {
        name: string;
        status: string;
        file: any;
    };

    const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
        setLoading(true)
        try {
            const fileObj = values.file?.[0]?.originFileObj;
            const newVar = await API_TREES.saveOrUpdateTree(fileObj, values.name, values.status);
        } finally {
            setLoading(false)
        }


    }


    const statuses = Constants.TREE_STATUSES.map(item => {
        return {value: item, label: item}
    })

    const clearAndClose = () => {
        form.resetFields()
        close()
    }

    return (
        <Modal title='Создание дерева'
               onCancel={clearAndClose}
               footer={[]}
               open={isOpen}>
            <Form
                form={form}
                name='basic'
                labelCol={{span: 24}}
                initialValues={{remember: true}}
                autoComplete='off'
                onFinish={onFinish}
            >
                <Form.Item<FieldType>
                    name='name'
                    rules={[{required: true, message: 'Поле обязательно к заполнению'}]}
                    label={'Название дерева'}
                >
                    <Input/>
                </Form.Item>

                <Form.Item<FieldType>
                    name='status'
                    rules={[{required: true, message: 'Поле обязательно к заполнению'}]}
                    label={'Статус'}
                >
                    <Select
                        options={statuses}
                        defaultValue={'Выбрать статус'}
                    />
                </Form.Item>

                <Form.Item<FieldType>
                    name="file"
                    label="Изображение дерева"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e?.fileList}
                    rules={[{required: true, message: 'Загрузите изображение'}]}
                >
                    <Upload
                        beforeUpload={() => false}
                        maxCount={1}
                        listType="picture"
                    >
                        <Button icon={<UploadOutlined/>}>Загрузить файл</Button>
                    </Upload>
                </Form.Item>

                <Form.Item wrapperCol={{offset: 9, span: 8}}>
                    <Button loading={loading} type='primary' htmlType='submit'>
                        Добавить
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}
